import { Pipe, PipeTransform } from '@angular/core';
import { PolishDeclination } from '../services/polish-declination';

@Pipe({name: 'optionalMembers'})
export class OptionalMembersPipe implements PipeTransform {
  transform(_input: number, _fullSentence: boolean = false): string {
    const declinations: Array<string> = [
      'numeru',
      'numerów',
      'numerów'
    ];

    return _input + ' ' + PolishDeclination(_input, declinations);
  }
}

@Pipe({name: 'maxOptionalMembers'})
export class MaxOptionalMembersPipe implements PipeTransform {
  transform(_input: number, _fullSentence: boolean = false): string {
    const declinations: Array<string> = [
      'numer',
      'numery',
      'numerów'
    ];

    const phones: Array<string> = [
      'telefonu',
      'telefonów',
      'telefonów'
    ];

    if (_fullSentence) {
      return _input + ' ' + PolishDeclination(_input, declinations) + ' ' + PolishDeclination(_input, phones);
    } else {
      return _input + ' ' + PolishDeclination(_input, declinations);
    }
  }
}
